import React from "react";
import './landingpage.css';
import Video from './video2.mp4';
import { useTypewriter, Cursor } from "react-simple-typewriter";
const LandingPage = () => {
    const [text] = useTypewriter({
        words: ['Connect', 'Collaborate', 'Create'],
        loop: Infinity,
    });
    return (
        <div className="landingpage">
            <video loop muted autoPlay={true} preload={true} data-preload="true" playsInline className="video-bg">
                <source src={Video} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="bg-overlay">
                <h1>UPES</h1>
                <h1>OZONE STUDENT SOCIETY</h1>
                <h2 className="tagline">Breathing Life Into Healthier Communities</h2>
                <div className="heading-container">
                    <h2 className="intro">
                        At Ozone <span className="val">{text}</span><Cursor />
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
